// Exact SVG paths ported from the approved prototype (Luminaire_Home_Pagination.html)
// so icon strokes/proportions match pixel-for-pixel, rather than swapping in a
// different icon set with different weights.

function Svg({ size = 15, children }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2">
      {children}
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <Svg {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </Svg>
  );
}

export function HistoryIcon(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </Svg>
  );
}

export function EyeIcon(props) {
  return (
    <Svg {...props}>
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </Svg>
  );
}

export function OpenIcon(props) {
  return (
    <Svg {...props}>
      <path d="M14 4h6v6" />
      <path d="M20 4l-9 9" />
      <path d="M19 13v6a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h6" />
    </Svg>
  );
}

export function DownloadIcon(props) {
  return (
    <Svg {...props}>
      <path d="M12 3v12" />
      <path d="M6 11l6 6 6-6" />
      <path d="M5 20h14" />
    </Svg>
  );
}

export function RetryIcon(props) {
  return (
    <Svg {...props}>
      <path d="M3 12a9 9 0 109-9c-2.5 0-4.7 1-6.4 2.6" />
      <path d="M3 4v5h5" />
    </Svg>
  );
}

export function ArrowLeftIcon(props) {
  return (
    <Svg {...props}>
      <path d="M15 18l-6-6 6-6" />
    </Svg>
  );
}

export function ArrowRightIcon(props) {
  return (
    <Svg {...props}>
      <path d="M9 18l6-6-6-6" />
    </Svg>
  );
}

export function WarnIcon(props) {
  return (
    <Svg {...props}>
      <path d="M12 9v4" />
      <circle cx="12" cy="16.5" r=".6" fill="currentColor" stroke="none" />
      <path d="M10.3 3.9L2.6 17.5a1.5 1.5 0 001.3 2.2h16.2a1.5 1.5 0 001.3-2.2L13.7 3.9a1.5 1.5 0 00-2.6 0z" />
    </Svg>
  );
}

export function StackIcon(props) {
  return (
    <Svg {...props}>
      <rect x="4" y="5" width="16" height="4" rx="1" />
      <rect x="4" y="10" width="16" height="4" rx="1" />
      <rect x="4" y="15" width="16" height="4" rx="1" />
    </Svg>
  );
}

export function ShareIcon(props) {
  return (
    <Svg {...props}>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="M8.6 10.5l6.8-3.9M8.6 13.5l6.8 3.9" />
    </Svg>
  );
}

export function CheckIcon(props) {
  return (
    <Svg {...props}>
      <path d="M20 6L9 17l-5-5" />
    </Svg>
  );
}

export function TrashIcon(props) {
  return (
    <Svg {...props}>
      <path d="M4 7h16" />
      <path d="M9 7V4h6v3" />
      <path d="M6 7l1 13a1 1 0 001 1h8a1 1 0 001-1l1-13" />
      <path d="M10 11v6M14 11v6" />
    </Svg>
  );
}

// Filled star — the standard "this is the primary one" business symbol
// (same convention as a starred email/favorited item), used in place of a
// text "primary" tag wherever the row label can be long enough to push a
// text badge out of view (see LlmScoreTable.js).
export function StarIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 15} height={props.size || 15} fill="currentColor" stroke="none">
      <path d="M12 2.5l2.9 6.5 7.1.6-5.4 4.7 1.7 6.9L12 17.4 5.7 21.2l1.7-6.9-5.4-4.7 7.1-.6L12 2.5z" />
    </svg>
  );
}

export function ChevronDownIcon(props) {
  return (
    <Svg {...props}>
      <path d="M6 9l6 6 6-6" />
    </Svg>
  );
}

export function CategoryIcon(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="5" r="2.4" />
      <circle cx="5" cy="18" r="2.4" />
      <circle cx="19" cy="18" r="2.4" />
      <path d="M12 7.4V13M12 13L6.6 16.2M12 13l5.4 3.2" />
    </Svg>
  );
}
